import { Route, Routes, useLocation } from "react-router-dom";

import HomePage from './pages/HomePage';
import ServicesPage from './pages/ServicesPage';
import MembershipPage from './pages/MembershipPage';
import AboutPage from './pages/AboutPage';
import PartnersPage from './pages/PartnersPage';
import BlogsPage from './pages/BlogsPage';
import ContactPage from './pages/ContactPage';
import { useEffect } from "react";
import WhatsAppButton from "./components/WhatsAppButton";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";


function App() {
  const location = useLocation();
  console.log(process.env.REACT_APP_BUILD_ID);


  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  return (
    <div className="relative min-h-screen bg-cream flex flex-col">
      <Navbar />
      <main className="flex-grow"> {/* main tag for semantic HTML */}
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/services" element={<ServicesPage />} />
          <Route path="/membership" element={<MembershipPage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/partners" element={<PartnersPage />} />
          <Route path="/blogs" element={<BlogsPage />} />
          <Route path="/contact" element={<ContactPage />} />
          {/* Add a catch-all route for 404 if needed */}
          {/* <Route path="*" element={<NotFoundPage />} /> */}
        </Routes>
        <WhatsAppButton />
      </main>
      <Footer />

    </div>
  );
}
export default App;
